import { Notyf } from 'notyf';
import { Controller } from '@hotwired/stimulus';

import 'notyf/notyf.min.css';

export default class extends Controller {
  connect() {
    this.notyf = new Notyf({
      duration: 5000,
      position: {
        x: 'right',
        y: 'top',
      },
      types: [
        {
          type: 'notice',
          backgroundColor: '#3B7DDD',
          icon: {
            className: 'notyf__icon--success',
            tagName: 'i',
          },
        },
        {
          type: 'success',
          backgroundColor: '#28a745',
          icon: {
            className: 'notyf__icon--success',
            tagName: 'i',
          },
        },
        {
          type: 'warning',
          backgroundColor: '#ffc107',
          icon: {
            className: 'notyf__icon--error',
            tagName: 'i',
          },
        },
        {
          type: 'danger',
          backgroundColor: '#dc3545',
          icon: {
            className: 'notyf__icon--error',
            tagName: 'i',
          },
        },
      ],
    });

    if (this.element.dataset.flashSuccess) {
      this.notyf.success(this.element.dataset.flashSuccess);
    } else {
      const f = JSON.parse(this.element.dataset.flash);
      f.forEach((flashA) => {
        let method = flashA[0];
        if (method === 'alert') {
          method = 'error';
        } else if (method === 'notice') {
          method = 'success';
        }
        this.notyf[method](flashA[1]);
      });
    }
  }
}
